export default "__VITE_ASSET__CMyfTpzp__"